import { IBudgetProgramAddEditRequest } from '../../../../model/sge/budget-program/request/budget-program-add-edit-request';
import { IBudgetUnitResponse } from '../../../../model/sge/budget-unit/response/budget-unit-response';

export type BudgetProgramCreateEditState = {
    budgetProgramId?: string;
    budgetProgramRequest: IBudgetProgramAddEditRequest;
    budgetUnits: IBudgetUnitResponse[];
    showValidationErrors: boolean;
};

export enum ACTION_TYPES {
    setBudgetProgramId = 'setBudgetProgramId',
    setBudgetProgramRequest = 'setBudgetProgramRequest',
    updateBudgetProgramRequest = 'updateBudgetProgramRequest',
    setBudgetUnits = 'setBudgetUnits',
    setShowValidationErrors = 'setShowValidationErrors',
}

export const BudgetProgramCreateEditReducer = (state: BudgetProgramCreateEditState, action: any): BudgetProgramCreateEditState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setBudgetProgramId:
            return { ...state, budgetProgramId: payload };
        case ACTION_TYPES.setBudgetProgramRequest:
            return { ...state, budgetProgramRequest: payload };
        case ACTION_TYPES.updateBudgetProgramRequest:
            return { ...state, budgetProgramRequest: { ...state.budgetProgramRequest, ...payload } };
        case ACTION_TYPES.setBudgetUnits:
            return { ...state, budgetUnits: payload };
        case ACTION_TYPES.setShowValidationErrors:
            return { ...state, showValidationErrors: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
